import { getCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';

export enum COOKIE {
  USER_ID = 'user_id',
  ENABLE_MARKETING = 'enable_marketing_cookies',
}

// pass {req,res} as context when using server-side
export const getUserId = (context?: OptionsType) =>
  getCookie(COOKIE.USER_ID, context);
